import { FC } from 'react';
// components
import AddFormulationSyrupType from 'components/main/FormulationSyrupType/Add';

const Add: FC = () => <AddFormulationSyrupType />;

export default Add;
